'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const BarChartClient = dynamic(() => import('@/app/sales-engine/components/FollowUpFunnelChart'), { ssr: false });

export default function FollowUpFunnel() {
  const stages = [
    { id: 'ff-s1', stage: 'Seq 1 — Initial Contact', count: 38, value: '$612,400' },
    { id: 'ff-s2', stage: 'Seq 2 — Value Follow-up', count: 44, value: '$524,200' },
    { id: 'ff-s3', stage: 'Seq 3 — Urgency Trigger', count: 29, value: '$384,100' },
    { id: 'ff-s4', stage: 'Seq 4 — Final Offer', count: 21, value: '$218,800' },
    { id: 'ff-s5', stage: 'Seq 5 — Last Chance', count: 10, value: '$80,500' },
  ];

  return (
    <div className="bg-card rounded-lg card-shadow border border-border h-full">
      <div className="px-5 py-4 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">Follow-up Sequence Funnel</h3>
        <p className="text-xs text-muted-foreground mt-0.5">142 active sequences · 5-touch cadence</p>
      </div>
      <div className="px-5 py-4">
        <BarChartClient />
        <div className="mt-4 space-y-2">
          {stages?.map((s) => (
            <div key={s?.id} className="flex items-center justify-between text-xs">
              <span className="text-muted-foreground truncate flex-1">{s?.stage}</span>
              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="font-tabular text-foreground font-medium">{s?.count}</span>
                <span className="font-tabular text-success font-semibold w-20 text-right">{s?.value}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 pt-3 border-t border-border">
          <div className="flex justify-between text-xs">
            <span className="text-muted-foreground">Pipeline conversion rate</span>
            <span className="font-semibold text-success">34.2%</span>
          </div>
          <div className="flex justify-between text-xs mt-1">
            <span className="text-muted-foreground">Avg sequence response</span>
            <span className="font-semibold text-foreground">2.4 days</span>
          </div>
        </div>
      </div>
    </div>
  );
}